module.exports = __webpack_public_path__ + "img/1700f.6d9a94fb.png";